'use client'

import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useBooking } from '../../model/bookingContext'
import { BookingStepEnum } from '../../model/bookingTypes'
import { BookingStep } from './BookingStep'
import { IncompletedStepLabel } from './IncompletedStepLabel'
import { Summary } from './Summary'
import { CompanionForm } from './CompanionForm'

export function CompanionStep() {
  const { state, goToStep, isStepCompleted } = useBooking()

  if (state.currentStep === BookingStepEnum.COMPANION) {
    return (
      <BookingStep className="sm:!rounded-br-none">
        <BookingStep.Title>
          <Trans>Companion</Trans>
        </BookingStep.Title>
        <BookingStep.Content>
          <CompanionForm />
        </BookingStep.Content>
      </BookingStep>
    )
  }

  if (isStepCompleted(BookingStepEnum.COMPANION)) {
    const summaryText = state.companion ? `${state.companion.firstName} ${state.companion.lastName}` : t`No companion`

    return <Summary icon="👥" label={t`Companion`} onEdit={() => goToStep(BookingStepEnum.COMPANION)} text={summaryText} />
  }

  return (
    <IncompletedStepLabel icon="👥">
      <Trans>Companion</Trans>
    </IncompletedStepLabel>
  )
}
